export default __webpack_public_path__ + "static/email-templates-insert-fields-75d5cab079ce438ed8ab081dc4de0f4b.mp4";